import type { SVGProps } from "react";
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg width="50" height="46" viewBox="0 0 50 46" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="scale(1.92) translate(-12, -12)">
      <rect x="0.65" y="0.65" width="48.7" height="48.7" rx="8.97963" />
      <rect x="13.25" y="13.75" width="4.5" height="4.5" rx="2.25" stroke="currentColor" strokeWidth="1.5" />
      <rect x="20.25" y="13.75" width="16.5" height="4.5" rx="2.25" stroke="currentColor" strokeWidth="1.5" />
      <rect
        x="38.75"
        y="27.25"
        width="4.5"
        height="4.5"
        rx="2.25"
        transform="rotate(180 37.75 27.25)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="27.75"
        y="27.25"
        width="16.5"
        height="4.5"
        rx="2.25"
        transform="rotate(180 28.75 27.25)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect x="13.25" y="31.75" width="4.5" height="4.5" rx="2.25" stroke="currentColor" strokeWidth="1.5" />
      <rect x="20.25" y="31.75" width="16.5" height="4.5" rx="2.25" stroke="currentColor" strokeWidth="1.5" />
    </g>
  </svg>
);
export default SvgFilter;
